import Helpers from '..';

const shouldInjectSubscriptionOrNewsletter = ({ options, viewport, component }) => {
  const {
    currentRuleComponentTypeWordCount: wordCount,
    currentRuleInjectedComponentCount,
    currentType,
    nextType,
    props: {
      adSettings: {
        beforeInlineSubsMobileAds,
        beforeInlineSubsDesktopAds,
        beforeInlineNewsletterMobileAds,
        beforeInlineNewsletterDesktopAds,
      },
    },
  } = options;
  let configForViewport;

  if (component === 'newsletter') {
    if (viewport === 'mobile') {
      if (beforeInlineNewsletterMobileAds === beforeInlineSubsMobileAds) return false;
      configForViewport = beforeInlineNewsletterMobileAds;
    } else if (viewport === 'desktop') {
      if (beforeInlineNewsletterDesktopAds === beforeInlineSubsDesktopAds) return false;
      configForViewport = beforeInlineNewsletterDesktopAds;
    }
  } else if (component === 'subscription') {
    if (viewport === 'mobile') {
      if (beforeInlineNewsletterMobileAds === beforeInlineSubsMobileAds) return false;
      configForViewport = beforeInlineSubsMobileAds;
    } else if (viewport === 'desktop') {
      if (beforeInlineNewsletterDesktopAds === beforeInlineSubsDesktopAds) return false;
      configForViewport = beforeInlineSubsDesktopAds;
    }
  }

  if (!configForViewport || (configForViewport && configForViewport === 0)) return false;
  if (Helpers.hasRuleBeenInjected(currentRuleInjectedComponentCount)) return false;
  if (Helpers.isBetweenTwoTextBlocks({ currentType, nextType }) === false) return false;

  return wordCount > configForViewport;
};

export default shouldInjectSubscriptionOrNewsletter;
